import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AutoSeo from "@/components/feature/AutoSeo";
import SiteSchema from "@/components/feature/SiteSchema";
import { contactInfo } from "@/mocks/site";
import { useAnalyticsTracking } from "@/hooks/useAnalyticsTracking";

export default function SiteLayout() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  useAnalyticsTracking();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <AutoSeo />
      <SiteSchema />
      <Navbar />
      <main className={`flex-1 ${isHome ? "" : "pt-16 md:pt-[108px]"}`}>
        <div key={location.pathname} className="animate-page-fade">
          <Outlet />
        </div>
      </main>
      <Footer />

      {/* Floating call + whatsapp */}
      <div className="fixed bottom-5 right-4 z-40 flex flex-col gap-3 md:bottom-7 md:right-6">
        <a
          href={contactInfo.phoneHref}
          aria-label="Call us"
          title="Call Lahari Packers and Movers"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-transform hover:scale-105"
        >
          <i className="ri-phone-fill text-2xl" />
        </a>
        <a
          href={contactInfo.whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp us"
          title="Chat with us on WhatsApp"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 hover:bg-[#1EBE5B]"
        >
          <i className="ri-whatsapp-line text-2xl" />
        </a>
      </div>
    </div>
  );
}